import React from "react";
import { Accordion, Card } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faChevronDown } from "@fortawesome/free-solid-svg-icons";
import styled from "styled-components";

const AccordionContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0;
  margin-top: 16px;
  margin-bottom: 16px;
  border-radius: 5px;
  background-color: white;
`;

const AccordionNameSection = styled.span`
  display: flex;
  align-items: center;
`;

const AccordionTitle = styled.span`
  color: #212322;
  padding-left: 1em;
  font-weight: 600;
  font-size: 16px;
`;

const textDescriptionDemanda = `Análise detalhada das demandas contratadas versus demandas propostas para otimização de custos. Identifique oportunidades de redução com base em ociosidade, ultrapassagens e Take-or-Pay.`;

// Mock determinístico de dados de demandas
// TODO: substituir por dados reais derivados de profiles quando a API estiver pronta
const mockDemandaData = [
  {
    unidade: "CONCEIÇÃO DO COITÉ",
    ths: "A4 AZUL",
    demandasContratadas: "520 FP/ 500 P",
    demandasPropostas: "Manter atual",
    economia: "-",
    demOciosa: 10,
    demUltrapassagem: 0,
    demDentroTake: 2,
  },
  {
    unidade: "EUNÁPOLIS",
    ths: "A4 VERDE",
    demandasContratadas: "750 FP",
    demandasPropostas: "600 FP",
    economia: "R$ 3.750,00",
    demOciosa: 12,
    demUltrapassagem: 0,
    demDentroTake: 0,
  },
  {
    unidade: "FEIRA DE SANTANA",
    ths: "A4 VERDE",
    demandasContratadas: "750 FP",
    demandasPropostas: "720 FP",
    economia: "R$ 753,00",
    demOciosa: 2,
    demUltrapassagem: 0,
    demDentroTake: 0,
  },
  {
    unidade: "ILHÉUS",
    ths: "A4 VERDE",
    demandasContratadas: "830 FP",
    demandasPropostas: "750 FP",
    economia: "R$ 2.243,00",
    demOciosa: 9,
    demUltrapassagem: 0,
    demDentroTake: 0,
  },
  {
    unidade: "ITABUNA",
    ths: "A4 VERDE",
    demandasContratadas: "750 FP",
    demandasPropostas: "550 FP",
    economia: "R$ 5.028,00",
    demOciosa: 12,
    demUltrapassagem: 0,
    demDentroTake: 0,
  },
  {
    unidade: "JACOBINA",
    ths: "A4 AZUL",
    demandasContratadas: "770 FP / 740 P",
    demandasPropostas: "600 FP / 600 P",
    economia: "R$ 8.400,00",
    demOciosa: 12,
    demUltrapassagem: 0,
    demDentroTake: 0,
  },
  {
    unidade: "JUAZEIRO",
    ths: "A4 AZUL",
    demandasContratadas: "800 FP / 780 P",
    demandasPropostas: "920 FP / 880 P",
    economia: "R$ 9.720,00",
    demOciosa: 3,
    demUltrapassagem: 9,
    demDentroTake: 0,
  },
  {
    unidade: "PORTO SEGURO",
    ths: "A4 AZUL",
    demandasContratadas: "675 FP / 600 P",
    demandasPropostas: "570 FP / 520 P",
    economia: "R$ 3.500,00",
    demOciosa: 12,
    demUltrapassagem: 0,
    demDentroTake: 0,
  },
  {
    unidade: "SALVADOR SÃO CRISTÓVÃO",
    ths: "A4 VERDE",
    demandasContratadas: "749 FP",
    demandasPropostas: "700 FP",
    economia: "R$ 897,00",
    demOciosa: 12,
    demUltrapassagem: 0,
    demDentroTake: 0,
  },
  {
    unidade: "TEXEIRA DE FREITAS",
    ths: "A4 VERDE",
    demandasContratadas: "750 FP",
    demandasPropostas: "650 FP",
    economia: "R$ 2.350,00",
    demOciosa: 10,
    demUltrapassagem: 0,
    demDentroTake: 0,
  },
  {
    unidade: "VITÓRIA DA CONQUISTA",
    ths: "A4 AZUL",
    demandasContratadas: "600 FP / 550 P",
    demandasPropostas: "Manter atual",
    economia: "-",
    demOciosa: 9,
    demUltrapassagem: 0,
    demDentroTake: 3,
  },
];

interface DemandaAccordionProps {
  // profiles: any[] | null; // TODO: habilitar quando a API estiver pronta
}

export function DemandaAccordion(_props: DemandaAccordionProps) {
  // TODO: substituir mockDemandaData pela derivação abaixo quando a API estiver pronta
  // const demandaData = profiles
  //   ? profiles
  //       .map((profile) =>
  //         typeof profile.demand_data === "string"
  //           ? JSON.parse(profile.demand_data)
  //           : profile.demand_data
  //       )
  //       .filter((data) => data !== undefined && data !== null)
  //   : [];

  const demandaData = mockDemandaData;

  if (!demandaData || demandaData.length === 0) return null;

  return (
    <Accordion>
      <AccordionContainer>
        <Card style={{ width: "100%" }}>
          <Accordion.Toggle
            as={Card.Header}
            variant="link"
            eventKey="0"
            flush="true"
            style={{
              display: "flex",
              justifyContent: "space-between",
              width: "100%",
              alignItems: "center",
              backgroundColor: "white",
              borderRadius: "5px 5px 5px 5px",
              paddingLeft: "2em",
              border: "1px solid #0072ce",
              minHeight: "70px",
            }}
          >
            <AccordionNameSection>
              <AccordionTitle>
                Comparação de viabilidade para cada demanda contratada
              </AccordionTitle>
            </AccordionNameSection>
            <FontAwesomeIcon
              icon={faChevronDown}
              size="lg"
              style={{ marginRight: "1.2em" }}
            />
          </Accordion.Toggle>

          <Accordion.Collapse eventKey="0">
            <Card.Body>
              <div style={{ margin: "32px 0 16px 0" }}>
                <div className="tableTitle d-flex align-items-center mb-3">
                  <span
                    className="clientDashboard-text fw-bold text-center"
                    style={{ flex: 3 }}
                  >
                    Comparação de viabilidade para cada demanda contratada
                  </span>
                </div>
                {textDescriptionDemanda.split("\n").map((paragraph, idx) => (
                  <p key={idx} className="text-muted small">
                    {paragraph}
                  </p>
                ))}
                <div style={{ overflowX: "auto" }}>
                  <table
                    style={{
                      width: "100%",
                      borderCollapse: "collapse",
                      marginTop: "16px",
                    }}
                  >
                    <thead>
                      <tr
                        style={{
                          backgroundColor: "#f5f5f5",
                          borderBottom: "2px solid #0072ce",
                        }}
                      >
                        <th
                          style={{
                            padding: "12px",
                            textAlign: "left",
                            fontWeight: "bold",
                            fontSize: "14px",
                            minWidth: "150px",
                            whiteSpace: "nowrap",
                          }}
                        >
                          Unidade
                        </th>
                        <th
                          style={{
                            padding: "12px",
                            textAlign: "left",
                            fontWeight: "bold",
                            fontSize: "14px",
                            minWidth: "90px",
                            whiteSpace: "nowrap",
                          }}
                        >
                          THS
                        </th>
                        <th
                          style={{
                            padding: "12px",
                            textAlign: "center",
                            fontWeight: "bold",
                            fontSize: "14px",
                            minWidth: "120px",
                          }}
                        >
                          Demandas contratadas
                        </th>
                        <th
                          style={{
                            padding: "12px",
                            textAlign: "center",
                            fontWeight: "bold",
                            fontSize: "14px",
                            minWidth: "120px",
                          }}
                        >
                          Demandas propostas
                        </th>
                        <th
                          style={{
                            padding: "12px",
                            textAlign: "center",
                            fontWeight: "bold",
                            fontSize: "14px",
                            minWidth: "160px",
                            whiteSpace: "nowrap",
                          }}
                        >
                          Economia mensal (R$)
                        </th>
                        <th
                          style={{
                            padding: "12px",
                            textAlign: "center",
                            fontWeight: "bold",
                            fontSize: "14px",
                            minWidth: "110px",
                            whiteSpace: "nowrap",
                          }}
                        >
                          Dem. Ociosa
                        </th>
                        <th
                          style={{
                            padding: "12px",
                            textAlign: "center",
                            fontWeight: "bold",
                            fontSize: "14px",
                            minWidth: "150px",
                            whiteSpace: "nowrap",
                          }}
                        >
                          Dem. Ultrapassagem
                        </th>
                        <th
                          style={{
                            padding: "12px",
                            textAlign: "center",
                            fontWeight: "bold",
                            fontSize: "14px",
                            minWidth: "140px",
                            whiteSpace: "nowrap",
                          }}
                        >
                          Dem. dentro do take
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      {demandaData.map((row, idx) => (
                        <tr
                          key={idx}
                          style={{
                            borderBottom: "1px solid #e0e0e0",
                            backgroundColor:
                              idx % 2 === 0 ? "#ffffff" : "#f9f9f9",
                          }}
                        >
                          <td
                            style={{
                              padding: "12px",
                              fontSize: "13px",
                              whiteSpace: "nowrap",
                            }}
                          >
                            {row.unidade}
                          </td>
                          <td
                            style={{
                              padding: "12px",
                              fontSize: "13px",
                              whiteSpace: "nowrap",
                            }}
                          >
                            {row.ths}
                          </td>
                          <td
                            style={{
                              padding: "12px",
                              textAlign: "center",
                              fontSize: "13px",
                              whiteSpace: "nowrap",
                            }}
                          >
                            {row.demandasContratadas}
                          </td>
                          <td
                            style={{
                              padding: "12px",
                              textAlign: "center",
                              fontSize: "13px",
                              whiteSpace: "nowrap",
                            }}
                          >
                            {row.demandasPropostas}
                          </td>
                          <td
                            style={{
                              padding: "12px",
                              textAlign: "center",
                              fontSize: "13px",
                              fontWeight: "bold",
                              color: "#28a745",
                              whiteSpace: "nowrap",
                            }}
                          >
                            {row.economia}
                          </td>
                          <td
                            style={{
                              padding: "12px",
                              textAlign: "center",
                              fontSize: "13px",
                              whiteSpace: "nowrap",
                            }}
                          >
                            {row.demOciosa}
                          </td>
                          <td
                            style={{
                              padding: "12px",
                              textAlign: "center",
                              fontSize: "13px",
                              whiteSpace: "nowrap",
                            }}
                          >
                            {row.demUltrapassagem}
                          </td>
                          <td
                            style={{
                              padding: "12px",
                              textAlign: "center",
                              fontSize: "13px",
                              whiteSpace: "nowrap",
                            }}
                          >
                            {row.demDentroTake}
                          </td>
                        </tr>
                      ))}
                      <tr
                        style={{
                          borderTop: "2px solid #0072ce",
                          backgroundColor: "#e8f4fd",
                        }}
                      >
                        <td
                          colSpan={4}
                          style={{
                            padding: "12px",
                            fontSize: "14px",
                            fontWeight: "bold",
                            textAlign: "right",
                          }}
                        >
                          Total de economia média mensal:
                        </td>
                        <td
                          style={{
                            padding: "12px",
                            textAlign: "center",
                            fontSize: "14px",
                            fontWeight: "bold",
                            color: "#28a745",
                          }}
                        >
                          {demandaData
                            .reduce((acc, row) => {
                              if (row.economia === "-") return acc;
                              const value = parseFloat(
                                row.economia
                                  .replace("R$", "")
                                  .trim()
                                  .replace(/\./g, "")
                                  .replace(",", ".")
                              );
                              return acc + (isNaN(value) ? 0 : value);
                            }, 0)
                            .toLocaleString("pt-BR", {
                              style: "currency",
                              currency: "BRL",
                            })}
                        </td>
                        <td colSpan={3} />
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </Card.Body>
          </Accordion.Collapse>
        </Card>
      </AccordionContainer>
    </Accordion>
  );
}
